import { Sell } from '@mui/icons-material'
import FacetList from './FacetList'
import FacetCreate from './FacetCreate'
import FacetEdit from './FacetEdit'

const facetsIndex = {
  icon: Sell,
  list: FacetList,
  edit: FacetEdit,
  create: FacetCreate,
}

export default facetsIndex
